
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/under-18",
      function () {
        return require("private-next-pages/under-18.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/under-18"])
      });
    }
  